import { i18nHelper } from "@/core/utils";

export let listService = {
  getPermissionModules,
};

function toTitleCase(str) {
  return str.toLowerCase().replace(/(?:^|\s)\w/g, function (match) {
    return match.toUpperCase();
  });
}

function getPermissionModules(val) {
  let permissionByModule = [];
  if (val) {
    val.forEach((x) => {
      let name = x.split("_")[0];
      let actions = x.split("_")[1];
      if (permissionByModule.find((y) => y.name == name)) {
        permissionByModule
          .find((y) => y.name == name)
          .actions.push({
            name: actions,
            value: x,
          });
      } else {
        permissionByModule.push({
          name: name,
          actions: [
            {
              name: actions,
              value: x,
            },
          ],
        });
      }
    });
  }
  const getChecked = (module, actions) => {
    if (val && permissionByModule.find((x) => x.name == module)) {
      return permissionByModule
        .find((x) => x.name == module)
        .actions.find((x) => x.value == actions);
    } else {
      return false;
    }
  };

  let list = [
    {
      name: toTitleCase(i18nHelper.getMessage("label.permissions")),
      children: [
        {
          name: toTitleCase(i18nHelper.getMessage("label.view")),
          id: "permissions_view",
          children: [],
          checked: getChecked("permissions", "permissions_view"),
        },
        {
          name: toTitleCase(i18nHelper.getMessage("label.add")),
          id: "permissions_add",
          children: [],
          checked: getChecked("permissions", "permissions_add"),
        },
        {
          name: toTitleCase(i18nHelper.getMessage("label.update")),
          id: "permissions_update",
          children: [],
          checked: getChecked("permissions", "permissions_update"),
        },
        {
          name: toTitleCase(i18nHelper.getMessage("label.delete")),
          id: "permissions_delete",
          children: [],
          checked: getChecked("permissions", "permissions_delete"),
        },
      ],
    },
    {
      name: toTitleCase(i18nHelper.getMessage("label.devops")),
      children: [
        {
          id: "devops_create_account",
          name: toTitleCase(i18nHelper.getMessage("label.createAccount")),
          children: [],
          checked: getChecked("devops", "devops_create_account"),
        },
        {
          id: "devops_account_logger",
          name: toTitleCase(i18nHelper.getMessage("label.accountLogger")),
          children: [],
          checked: getChecked("devops", "devops_account_logger"),
        },
      ],
    },
  ];
  return list;
}
